import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import {
  FormCheck, If, isEmptyObj,
  actions,
  appActions,
  SummingUp,
  DruckenModal,
  PrevNextButton, useNextPage, istEnumAuswahl, EnumVorgangsart,
} from 'ion-lib';
import SummingupWarenkorb from '../../components/SummingupWarenkorb';
import { getBannerFileName } from '../../helper';

const Druckmatrix = () => {
  const nextPage = useNextPage();
  const dispatch = useDispatch();
  const euBeratung = useSelector((state) => state.euBeratung);
  const druckmatrix = useSelector((state) => state.druckmatrix);
  const vorgangsart = useSelector((state) => state.daten.vorgangsart);

  useEffect(() => {
    dispatch(appActions.holeVorbelegungDruckmatrix());
  }, []);

  const handleNextClick = (e) => {
    dispatch(actions.updateByName('appDaten.druckmodal', true));
    dispatch(actions.updateByName('appDaten.tooltip_offset', e.target.getBoundingClientRect().y));
  };

  const handleDruck = () => {
    // validiere nach pdf druck, damit die vsnr vom server kommt
    dispatch(actions.updateByName('appDaten.druckmodal', false, () => {
      dispatch(appActions.ospPDFRequest(() => {
        dispatch(appActions.request('validiere', () => {
          nextPage();
        }));
      }));
    }));
  };

  if (isEmptyObj(druckmatrix)) {
    return (
      <Row>
        <Col className="p-0">
          <div className="spkpanel p-3 mb-3">
            <h4>Unterlagen für das Versicherungsunternehmen</h4>
          </div>
        </Col>

        <SummingUp
          bannerImg={getBannerFileName}
          buttons={(
            <PrevNextButton />
          )}
        >
          <SummingupWarenkorb />
        </SummingUp>
      </Row>
    );
  }

  const druckenText = istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUORDNUNG) ? `
  Nach dem Drucken sind keine Änderungen am Antrag mehr möglich!
  Der Antrag kann nicht gespeichert werden und muss auf der Folgeseite direkt freigegeben werden.
  ` : undefined;

  const felder = ['antrag', 'bedingungen', 'beratungsdoku', 'bedingungsverzicht'];

  return (
    <Row>
      <Col>
        <div className="spkpanel p-3 mb-3">
          <h4>Unterlagen für das Versicherungsunternehmen</h4>
          {felder.map((elem) => (
            druckmatrix.originalVu[elem].relevant
            && (
              <FormCheck
                {...druckmatrix.originalVu[elem]}
                onChange={(e) => dispatch(actions.updateByEvent(e))}
                name={`druckmatrix.originalVu.${elem}.value`}
                id={`druckmatrix.originalVu.${elem}.value`}
                right
                key={`originalVu${elem}`}
              />
            )
          ))}
        </div>

        <div className="spkpanel p-3 mb-3">
          <h4>Druckunterlagen Kunde</h4>
          <If predicate={euBeratung.epostfach.relevant}>
            <FormCheck
              {...euBeratung.epostfach}
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              name="euBeratung.epostfach.value"
              id="euBeratung.epostfach.value"
              label={(
                <span>
                  ePostfach
                  &nbsp;
                  <i className="fa fa-fw fa-cloud-upload" />
                </span>
              )}
              ueberschreibbar={false}
              right
            />
          </If>
          {felder.map((elem) => (
            druckmatrix.kopieKunde[elem].relevant
            && (
              <FormCheck
                {...druckmatrix.kopieKunde[elem]}
                onChange={(e) => dispatch(actions.updateByEvent(e))}
                name={`druckmatrix.kopieKunde.${elem}.value`}
                id={`druckmatrix.kopieKunde.${elem}.value`}
                right
                key={`kopieKunde${elem}`}
              />
            )
          ))}
        </div>

        <div className="spkpanel p-3">
          <h4>Druckunterlagen Vermittler</h4>
          {felder.map((elem) => (
            druckmatrix.kopieVermittler[elem].relevant
            && (
              <FormCheck
                {...druckmatrix.kopieVermittler[elem]}
                onChange={(e) => dispatch(actions.updateByEvent(e))}
                name={`druckmatrix.kopieVermittler.${elem}.value`}
                id={`druckmatrix.kopieVermittler.${elem}.value`}
                right
                key={`kopieVermittler${elem}`}
              />
            )
          ))}
        </div>

        <DruckenModal handleDruck={handleDruck} text={druckenText} />

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              nextProps={{
                text: 'Drucken',
              }}
              onNextClick={handleNextClick}
            />
          </Col>
        </Row>
      </Col>

      <SummingUp bannerImg={getBannerFileName}>
        <SummingupWarenkorb
          nolink
        />
      </SummingUp>
    </Row>
  );
};

export default Druckmatrix;
